import * as React from "react";
import { forwardRef } from "react";
const SvgNote = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M.5.5v17h11.9l.241-.217 4.636-4.636.223-.247V.5zm1.545 1.545h13.91v9.273h-4.637v4.636H2.045Zm10.819 10.819h1.98l-1.98 1.98Z", className: "s5e739d27cef41151de11568365ba496b__b" }));
const ForwardRef = forwardRef(SvgNote);
export { ForwardRef as ReactComponent };
